// extracted by mini-css-extract-plugin
export default {"specialties":"specialty_specialties__4ER9g","specialty":"specialty_specialty__oAwdg"};